import React from "react";
import stilePulsanti from "../../../interfaccia/stilePulsanti";
import IconaContatto from "./IconaContatto";

function RiquadrinoContatto({
    elemento,
    funzioneScegliID,
    scelto
}) {

    const contatto = elemento

    return (
        <div
            className={"sfondoBiancoTema br4 pa2 flex flex-wrap mb3"}
        >
            <div className="w-100 tl pa3 bb bordoColAlt tc">
                <strong className="f5">{contatto.nome}</strong>
            </div>
            <div className="flex w-100 bb bordoColAlt">
                <div className="w-20 tc br bordoColAlt pa2">
                    <IconaContatto nomeIcona={"hail"} boolean={contatto["rappresentante"]} testoTooltip={"Rappresentante"} />
                </div>     
                <div className="w-20 tc br bordoColAlt pa2">
                    <IconaContatto nomeIcona={"support_agent"} boolean={contatto["customer"]} testoTooltip={"Customer care"} />
                </div>    
                <div className="w-20 tc br bordoColAlt pa2">
                    <IconaContatto nomeIcona={"hardware"} boolean={contatto["warranty"]} testoTooltip={"Warranties"} />
                </div>   
                <div className="w-20 tc br bordoColAlt pa2">
                    <IconaContatto nomeIcona={"image"} boolean={contatto["immagini"]} testoTooltip={"Immagini/marketing"} />
                </div>           
                <div className="w-20 tc pa2">
                    <IconaContatto nomeIcona={"list"} boolean={contatto["ean"]} testoTooltip={"EAN"} />
                </div>           
            </div>
            <div className="w-100 tc pa2 bb bordoColAlt">
                <div className="f6">{contatto.note}</div>
            </div>
            <div className="w-100 tc pa2 bb bordoColAlt">
                <div className="f6">{contatto.mail}</div>
            </div>
            <div className="w-100 tc pa2 bordoColAlt">
                <div className="f6">{contatto.cell}</div>
            </div>
            {/* <div className="flex w-100 bb bordoColAlt">
                <div className="w-50 tc br bordoColAlt pa2">
                    DATA ORDINE<br />
                    <strong>{ordine.dataOrd && umanizzaDataSenzaOre(ordine.dataOrd)}</strong>
                </div>
                <div className={"w-50 tc bordoColAlt pa2"}>
                    TIPO<br />
                    <strong>{ordine["Tipo"]}</strong>
                </div>
            </div>
            <div className="flex w-100 bb bordoColAlt">
                <div className="w-50 tc br bordoColAlt pa2">
                    DATA PARTENZA<br />
                    <strong>{ordine["Data_partenza"] && umanizzaDataSenzaOre(ordine["Data_partenza"])}</strong>
                </div>
                <div className={"w-50 tc bordoColAlt pa2"}>
                    MAGAZZINO PARTENZA<br />
                    <strong>{ordine["Partenza_da"]}</strong>
                </div>
            </div> */}

            {!scelto && <div className="w-100 tc">
                <button
                    className={stilePulsanti.buttonClassesWhite}
                    onClick={(e) => funzioneScegliID(contatto.id, "idContatto", 5, "contatto", contatto)}>
                    SCEGLI
                </button>
            </div>}      
        </div>

    )
}

export default RiquadrinoContatto;